import React from 'react'
import PropTypes from 'prop-types'
import { mdiOpenInNew } from '@mdi/js'
import ORCID from 'simple-icons/icons/orcid'

import { Icon } from '@jcu/cookbook-react'

const OrcidIdLink = ({ orcidId, sandbox, format, size, showIcon, ...rest }) => {
  const urlBase = `https://${(sandbox && 'sandbox.') || ''}orcid.org/`
  return (
    <a
      href={`${urlBase}${orcidId}`}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {showIcon && (
        <Icon
          path={ORCID.path}
          color={`${ORCID.hex}`}
          title="ORCID iD"
          className="me-1"
          style={{ width: size }}
        />
      )}
      {format === 'full' && (
        <span className="d-none d-sm-inline d-md-none d-lg-inline">
          {urlBase}
        </span>
      )}
      {orcidId}
      <Icon
        className="text-muted ms-1"
        style={{ verticalAlign: 'middle' }}
        path={mdiOpenInNew}
        size="0.75em"
        title="Opens in new window"
      />
    </a>
  )
}

OrcidIdLink.propTypes = {
  orcidId: PropTypes.string.isRequired,
  sandbox: PropTypes.bool,
  format: PropTypes.oneOf(['full', 'compact']),
  showIcon: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
}

OrcidIdLink.defaultProps = {
  sandbox: false,
  format: 'full',
  showIcon: true,
  size: '1.5rem',
}

export default OrcidIdLink
